import { contactsExportType } from '../const/contactsExportType.js'
import { tagMetadataKeys } from '../export/tagMetadataKeys.ts'
import {
	getConnectionsCount,
	getContactsFromMyConnections
} from '../linkedInExportApi.js'
import type { ContactsIteratorResult, IBroker } from './types.ts'

interface GetConnectionsCountResponse {
	count: number
}

interface GetConnectionsResponse {
	contacts: unknown[]
	paging: { start: number; count: number }
}

export class LinkedInMyConnectionsIterator {
	#broker
	#canNext = true
	#start = 0
	#total: number | undefined = undefined
	#pageSize = 10
	#metadata

	constructor(broker: IBroker) {
		this.#broker = broker
		this.#metadata = [
			{
				key: tagMetadataKeys.ExportStartedKey,
				value: tagMetadataKeys.TrueValue
			}
		]
	}

	async getNext(metadata?: object): Promise<ContactsIteratorResult> {
		if (!this.#total) {
			const response = (await getConnectionsCount(
				this.#broker,
				metadata
			)) as GetConnectionsCountResponse
			this.#total = response.count
		}

		const response = (await getContactsFromMyConnections(
			this.#broker,
			this.#start,
			this.#pageSize,
			metadata
		)) as GetConnectionsResponse

		const isNotAllContactsProcessed =
			this.#total >= response.paging.start + response.paging.count
		this.#canNext = isNotAllContactsProcessed
		if (this.#canNext) {
			this.#start += this.#pageSize
		}

		const result: ContactsIteratorResult = {
			found: response.contacts,
			processed: isNotAllContactsProcessed
				? response.paging.count
				: this.#total - response.paging.start
		}
		return result
	}

	canMove() {
		return this.#canNext
	}

	getTotal() {
		return this.#total
	}

	getMetadata() {
		return this.#metadata
	}

	getType() {
		return contactsExportType.linkedInMyConnections
	}
}
